import { ApiClient } from "../api.client";
import {
  GetReferralInvitesUsersRequest,
  GetReferralInvitesUsersResponse,
  GetReferralUserRequest,
  GetReferralUserResponse,
  GetReferralUsersRequest,
  GetReferralUsersResponse,
  SetReferralPaymentSettingsRequest,
  SetReferralPaymentSettingsResponse,
} from "./types";

const ReferralsApi = {
  getReferralUsers(params?: GetReferralUsersRequest) {
    return ApiClient.get<GetReferralUsersResponse>("/admin/referrals", {
      params,
    });
  },
  getReferralUser(params: GetReferralUserRequest) {
    return ApiClient.get<GetReferralUserResponse>(
      `/admin/referrals/${params.referralId}`,
    );
  },
  getReferralInvitesUsers(params: GetReferralInvitesUsersRequest) {
    return ApiClient.get<GetReferralInvitesUsersResponse>(
      "/admin/referrals/invites",
      {
        params,
      },
    );
  },
  setReferralPaymentSettings(body: SetReferralPaymentSettingsRequest) {
    return ApiClient.post<
      SetReferralPaymentSettingsRequest,
      SetReferralPaymentSettingsResponse
    >(`/admin/referrals/set-payment`, body);
  },
  downloadCsv(params?: GetReferralUserRequest) {
    return ApiClient.get<Blob>(`/admin/referrals/export/csv`, {
      params,
      headers: {
        Accept: "text/csv",
      },
      responseType: "blob",
    });
  },
};

export { ReferralsApi };
